<nav class="navbar">

    <div class="nombre-web">
        <img [src]="logo" width="24" height="24">
        <span style="margin: 20px 0; font-size: 1.5rem;"> {{ nombreWeb }}</span>
    </div>

    <div *ngIf="auth.isLoggedIn; else logging" class="acciones">
        <div *ngIf="auth.Session?.fk_rol === 1">
            <a [routerLink]="'/distribuidores'">Distribuidores</a> |
        </div>
        <div *ngIf="auth.Session?.fk_rol === 2">
            <a [routerLink]="'/distribuidor'">Ficha distribuidor </a> |
        </div>
        <a [routerLink]="'/facturas'">Facturas</a> |
        <div *ngIf="auth.Session?.fk_rol === 1">
            <a [routerLink]="'/factura'">Nueva Factura</a> |
        </div>
        <a [routerLink]="'/productos-facturados'">Productos Facturados</a> |
        <span> {{auth.Session?.nombre | uppercase}}</span>
        <button (click)="onLogout()">Logout</button>
    </div>
    <ng-template #logging>
        <div class="acciones">
            <button (click)="onLogin()">Login</button>
        </div>
    </ng-template>

</nav>